import axios from 'axios';

// Creo un'istanza di axios con configurazione base
const apiClient = axios.create({
  baseURL: '/api/fondazione/',
  timeout: 10000,                          
  headers: {
    'Content-Type': 'application/json',
  },
});

// Funzione generica per ottenere i dati di una pagina
export async function getPageData(endpoint) {
  try {
    const response = await apiClient.get(endpoint);
    return response.data;
  } catch (error) {
    console.error(`Errore durante il caricamento di ${endpoint}:`, error);
    throw error;
  }
}